import type { VirtualSynthConfig } from "./types";

/**
 * YO! FM Synth - Virtual FM synthesis
 * FM synthesis with modulation index, harmonicity, and modulation envelope control
 */
export const YO_FM_SYNTH_CONFIG: VirtualSynthConfig = {
  label: "YO! FM Synth",
  synthType: "FMSynth",

  // FM-specific CCs: modulation index, harmonicity, modulation envelope, carrier envelope
  supportedCCs: [1, 7, 11, 14, 15, 16, 17, 18, 19, 70, 71, 72, 73, 74, 75, 76, 77, 78],

  profile: {
    id: "yo-fm-synth-default",
    name: "Default",
    deviceName: "YO! FM Synth",
    userId: null,
    isPublic: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    ccConfig: [
      // === STANDARD MIDI CCs ===
      {
        number: 1,
        enabled: false,
        min: 0,
        max: 127,
        label: "Modulation",
      },
      {
        number: 7,
        enabled: false,
        min: 80,
        max: 110,
        label: "Volume",
      },
      {
        number: 11,
        enabled: false,
        min: 80,
        max: 110,
        label: "Expression",
      },

      // === FM SYNTHESIS PARAMETERS ===
      {
        number: 14,
        enabled: true,
        min: 0,
        max: 127,
        label: "Modulation Index",
      },
      {
        number: 15,
        enabled: true,
        min: 0,
        max: 127,
        label: "Harmonicity",
      },

      // === MODULATION ENVELOPE ===
      {
        number: 16,
        enabled: true,
        min: 0,
        max: 100, // ~1.57s - avoid extremely slow attacks
        label: "Mod Env Attack",
      },
      {
        number: 17,
        enabled: true,
        min: 5, // ~0.01s - avoid instant decay
        max: 127,
        label: "Mod Env Decay",
      },
      {
        number: 18,
        enabled: true,
        min: 20, // ~0.16 - avoid completely silent sustain
        max: 127,
        label: "Mod Env Sustain",
      },
      {
        number: 19,
        enabled: true,
        min: 5, // ~0.04s - avoid clicks
        max: 127,
        label: "Mod Env Release",
      },

      // === CARRIER ENVELOPE ===
      {
        number: 73,
        enabled: true,
        min: 3,
        max: 80,
        label: "Carrier Attack",
      },
      {
        number: 75,
        enabled: true,
        min: 10,
        max: 127,
        label: "Carrier Decay",
      },
      {
        number: 70,
        enabled: true,
        min: 0,
        max: 127,
        label: "Carrier Sustain",
      },
      {
        number: 72,
        enabled: true,
        min: 10,
        max: 127,
        label: "Carrier Release",
      },

      // === CARRIER OSCILLATOR ===
      {
        number: 76,
        enabled: true,
        min: 0,
        max: 127,
        label: "Carrier Type",
      },
      {
        number: 77,
        enabled: false,
        min: 0,
        max: 127,
        label: "Carrier Detune",
      },

      // === MODULATOR OSCILLATOR ===
      {
        number: 74,
        enabled: true,
        min: 0,
        max: 127,
        label: "Modulator Type",
      },
      {
        number: 78,
        enabled: false,
        min: 0,
        max: 127,
        label: "Portamento",
      },
    ],
  },
};
